"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSwitchEthereumChainMiddleware = exports.createRequestAccountsMiddleware = void 0;
const json_rpc_engine_1 = require("json-rpc-engine");
const types_1 = require("../types");
function createRequestAccountsMiddleware({ getAccounts }) {
    return (0, json_rpc_engine_1.createAsyncMiddleware)((req, res, next) => __awaiter(this, void 0, void 0, function* () {
        if (req.method !== 'eth_requestAccounts') {
            next();
            return;
        }
        res.result = yield getAccounts();
    }));
}
exports.createRequestAccountsMiddleware = createRequestAccountsMiddleware;
function createSwitchEthereumChainMiddleware({ changeSecretType }) {
    return (0, json_rpc_engine_1.createAsyncMiddleware)((req, res, next) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        if (req.method !== 'wallet_switchEthereumChain') {
            next();
            return;
        }
        const chainId = (_a = req.params[0]) === null || _a === void 0 ? void 0 : _a.chainId;
        const chain = types_1.SECRET_TYPES[Number(chainId)];
        if (chain && (yield changeSecretType(chain.secretType, chainId)))
            res.result = null;
        else
            res.error = { code: -32602, message: 'Chain not supported' };
    }));
}
exports.createSwitchEthereumChainMiddleware = createSwitchEthereumChainMiddleware;
